<div class="class-details container-fluid bg-light-gray p-0">
  <div class="row row-cols-1 gy-2 m-0">
    <div class="col mt-0 bg-primary-white navbar-spacer">
      <app-navbar class="fixed-top" />
    </div>
    <div class="col col-lg-6 py-3 bg-primary-white px-4">
      @for (venue of venueTimeslots; track $index; let idx = $index) {
        <div class="row row-cols-1 m-0">
          <div class="col rounded shadow mt-3">
            <div
              class="row py-3"
              data-bs-toggle="collapse"
              attr.data-bs-target="#venueTimeslot{{ $index }}"
            >
              <div class="col-10 px-3 text-secondary-purple fw-bold">
                {{ venue.name }}
              </div>
              <div class="col-2 text-end">
                <span class="fas fa-chevron-down text-secondary"></span>
              </div>
            </div>
            <div class="collapse show" id="venueTimeslot{{ $index }}">
              <div class="row p-2 pb-4">
                <div class="col-4 text-secondary">
                  {{ 'app.availability.days' | translate }}
                </div>
                <div class="col-8 text-secondary">
                  {{ 'app.availability.time' | translate }}
                </div>
                @for (
                  timeslot of venue.timeslots;
                  track $index;
                  let tsIndex = $index
                ) {
                  <div class="col-4 pt-2">
                    {{ `app.schedule.week.${timeslot.weekday}` | translate }}
                  </div>
                  <div class="col-8">
                    @for (
                      slot of timeslot.slots;
                      track $index;
                      let slotIndex = $index
                    ) {
                      <div class="pt-2">
                        <input
                          class="form-check-input me-2"
                          type="checkbox"
                          id="{{ `timeslot${idx}${tsIndex}${slotIndex}` }}"
                          (change)="doCheckTimeslot($event, venue, slot)"
                          [checked]="isPreferTimeslot(slot)"
                          [disabled]="isUserVenueLoading"
                        />
                        <label
                          class="form-check-label"
                          for="{{ `timeslot${idx}${tsIndex}${slotIndex}` }}"
                        >
                          @let meridiem =
                            slot.label?.startsWith('AM') ? 'am' : 'pm';
                          {{ `app.availability.${meridiem}` | translate }}
                          {{
                            `(${slot.start?.slice(0, 5)} - ${slot.end?.slice(0, 5)})`
                          }}
                        </label>
                      </div>
                    }
                  </div>
                  @if ($index < $count - 1) {
                    <div class="col-12 pt-2">
                      <div class="my-3 border-top"></div>
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      } @empty {
        <div class="ratio ratio-1x1">
          <div class="d-grid align-items-center justify-content-center">
            @if (isVenueLoading) {
              <div class="spinner-border text-secondary-purple"></div>
            } @else {
              <span>{{ 'app.availability.noAnyRecords' | translate }}</span>
            }
          </div>
        </div>
      }
    </div>
    <div class="col col-lg-6 py-3 px-4 bg-primary-white">
      <div class="fs-5 fw-bold text-secondary-purple mb-4">
        {{ 'app.availability.yourSelections' | translate }}:
      </div>
      <ul class="list-group">
        @for (venue of selecteVenues; track $index) {
          <li class="list-group-item">
            <div class="py-2 fw-bold">{{ venue.name }}</div>
            <div class="row row-cols-2">
              @for (timeslot of venue.timeslots; track $index) {
                <div class="col-4">
                  ● {{ `app.schedule.week.${timeslot.weekday}` | translate }}
                </div>
                <div class="col-8">
                  @for (slot of timeslot.slots; track $index) {
                    <div>
                      @let meridiem =
                        slot.label?.startsWith('AM') ? 'am' : 'pm';
                      {{ `app.availability.${meridiem}` | translate }}
                      {{
                        `(${slot.start?.slice(0, 5)} - ${slot.end?.slice(0, 5)})`
                      }}
                    </div>
                  }
                </div>
              }
            </div>
          </li>
        } @empty {
          <div class="ratio ratio-1x1">
            <div class="d-flex justify-content-center align-items-center">
              @if (isUserVenueLoading) {
                <div
                  class="spinner-border spinner-border text-secondary-purple"
                ></div>
              } @else {
                {{ 'app.availability.noAnyRecords' | translate }}
              }
            </div>
          </div>
        }
      </ul>
    </div>
    <div class="col g-0 pt-5 pb-4 bg-primary-white">
      <div class="container px-4">
        <button
          (click)="doSubmit()"
          [disabled]="isVenueLoading || isUserVenueLoading || isUpdating"
          class="btn btn-primary w-100"
        >
          {{ 'app.availability.submit' | translate }}
          @if (isUpdating) {
            <span class="spinner-border text-light spinner-border-sm"></span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
